import { Pipe, PipeTransform } from '@angular/core';
import { translate } from '@jsverse/transloco';

import { MetricSettings } from '../widget-predictive/widget-predictive.component';

@Pipe({
  name: 'metricSettings',
  standalone: true,
})
export class MetricSettingsPipe implements PipeTransform {
  transform(settings: MetricSettings): string {
    const scale = translate('metric-settings-pill.scale', {
      from: settings.min,
      to: settings.max,
    });

    let scoring: string;
    switch (settings.scoring) {
      default:
      case 'AVERAGE':
        scoring = translate('metric-settings-pill.average');
        break;
      case 'NPS':
        scoring = translate('metric-settings-pill.nps');
        break;
      case 'BOX':
        scoring = translate('metric-settings-pill.box', {
          isTop: settings.boxDirection === 'TOP',
          size: settings.boxSize,
        });
        break;
    }

    return `${scoring} ${scale}`;
  }
}
